var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgWhitePurchase(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_158",
    "data-name": "Group 158",
    transform: "translate(-1690.235 -1039.81)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_155",
    "data-name": "Rectangle 155",
    width: 20,
    height: 20,
    transform: "translate(1690.235 1039.81)",
    fill: "none"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_283",
    "data-name": "Path 283",
    d: "M1712.419,1083.544v-4.274h-3.4v3.276h-2.195v-3.276h-3.4v7.981h7.841a4.9,4.9,0,0,1-.03-.537A4.821,4.821,0,0,1,1712.419,1083.544Z",
    transform: "translate(-10.624 -32.424)",
    fill: "none"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_157",
    "data-name": "Group 157",
    transform: "translate(1691.786 1042.209)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_284",
    "data-name": "Path 284",
    d: "M1714.638,1057.441a.537.537,0,0,0-.016-.12l0-.012s0,0,0-.006a.531.531,0,0,0-.047-.108l-.012-.021a.53.53,0,0,0-.075-.1l-.013-.011a.524.524,0,0,0-.1-.073l-.005,0h0a.5.5,0,0,0-.116-.045l-.023-.006a.5.5,0,0,0-.106-.012h-10.258a.512.512,0,0,0-.283.086l-5.129,3.4,0,0-.02.016a.551.551,0,0,0-.052.044l-.022.024a.519.519,0,0,0-.039.048l-.019.029a.56.56,0,0,0-.028.053c0,.01-.01.021-.014.031a.54.54,0,0,0-.022.074c0,.006,0,.011,0,.017a.509.509,0,0,0-.009.1s0,.005,0,.008v9.236a.524.524,0,0,0,.519.528h8.792a4.92,4.92,0,0,1-.237-1.056h-8.036v-8.18h3.486v3.357h2.249v-3.357h3.486v4.381a5.016,5.016,0,0,1,1.038-.906,4.937,4.937,0,0,1,5.129-.176v-7.222S1714.638,1057.445,1714.638,1057.441Z",
    transform: "translate(-1698.214 -1056.925)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_285",
    "data-name": "Path 285",
    d: "M1753.86,1098.715a3.958,3.958,0,1,0,3.958,3.958A3.958,3.958,0,0,0,1753.86,1098.715Zm2.305,4.556h-1.708v1.708a.6.6,0,0,1-1.2,0v-1.708h-1.707a.6.6,0,0,1,0-1.2h1.707v-1.707a.6.6,0,0,1,1.2,0v1.707h1.708a.6.6,0,1,1,0,1.2Z",
    transform: "translate(-1739.854 -1090.591)",
    fill: "#fff"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWhitePurchase);
export default __webpack_public_path__ + "static/media/white_purchase.98b54338fc68b78334c96ae8dfdc1385.svg";
export { ForwardRef as ReactComponent };